import { Button, styled, CardContent, Card } from '@mui/material';

export const BookingCardHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const BookingCardContent = styled(CardContent)({
  textAlign: 'center',
  paddingBottom: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
});

export const BookingCardWrapper = styled(Card)({
  width: '47%',
  cursor: 'pointer',
  border: '1px solid',
  transition: 'all 0.4s ease',
});

export const BookingCardButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '& .MuiListItemText-secondary': {
      color: theme.palette.primary.contrastText,
    },
  },

  '&.MuiButton-outlined': {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
  '&:hover': {
    backgroundColor: '#5f51a666',
  },
  '&.MuiListItem-root': {
    justifyContent: 'space-between',
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.palette.primary.light,
  },
}));
